import React from 'react';
import './Products.css';

const Products = () => {
  return (
    <section className="products" id="products">
      <div className="container">
        <div className="section-header">
          <h2>Our Featured Product</h2>
          <p>Discover our flagship wireless water level monitoring solution</p>
        </div>
        
        <div className="product-showcase">
          <div className="product-main">
            <div className="product-image-section">
              <img src="/images/product.png" alt="Wireless Water Level Indicator" className="product-main-image" />
              <div className="product-badges">
                <span className="badge">IP-67 Rated</span>
                <span className="badge">10 Year Battery</span>
                <span className="badge">500m Range</span>
              </div>
            </div>
            
            <div className="product-content">
              <h3>Wireless Water Level Indicator & Alarm System</h3>
              <p className="product-description">
                The Wireless Water Level Indicator & Alarm System is designed to provide a simple, reliable, and maintenance-free solution for monitoring water levels in overhead tanks, underground reservoirs, and sumps. Operating on a secure 433–434 MHz wireless frequency, the system ensures smooth communication between the transmitter and the indicator, with a range of up to 500 meters in line of sight conditions.
              </p>
              
              <div className="product-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">📡</div>
                  <div className="highlight-content">
                    <h4>Advanced Wireless Technology</h4>
                    <p>Secure 433-434 MHz frequency with 500m range</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">🔋</div>
                  <div className="highlight-content">
                    <h4>Long-lasting Battery</h4>
                    <p>10-year battery life with low maintenance</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">💧</div>
                  <div className="highlight-content">
                    <h4>Precise Level Detection</h4>
                    <p>Water levels in 20%, 40%, 60%, 80%, 100% steps</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">🛡️</div>
                  <div className="highlight-content">
                    <h4>Weather Resistant</h4>
                    <p>IP-67 rated for water and dust protection</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="product-features-section">
            <h4>Key Features & Benefits</h4>
            <div className="features-grid">
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Wireless monitoring up to 500 meters</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Bright, easy-to-read display</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Integrated alarm system with relay output</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>10A at 230V AC relay capacity</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Configurable transmission intervals (1-1200 seconds)</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Advanced FSK modulation for stability</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>CPVC enclosure with IP-67 protection</span>
              </div>
              <div className="feature-item">
                <span className="feature-check">✓</span>
                <span>Prevents overflow and dry run situations</span>
              </div>
            </div>
          </div>
          
          <div className="product-applications">
            <h4>Perfect For</h4>
            <div className="applications-grid">
              <div className="application-card">
                <div className="app-icon">🏠</div>
                <h5>Domestic Households</h5>
                <p>Overhead tank monitoring for residential homes</p>
              </div>
              <div className="application-card">
                <div className="app-icon">🏢</div>
                <h5>Commercial Buildings</h5>
                <p>Water management for offices and establishments</p>
              </div>
              <div className="application-card">
                <div className="app-icon">🏭</div>
                <h5>Industrial Setups</h5>
                <p>Reservoir and sump monitoring for industries</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="product-cta">
          <h3>Interested in Our Water Level Monitoring System?</h3>
          <p>Get in touch with our experts to learn more about installation and pricing</p>
          <button 
            className="btn btn-primary btn-large"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Request Information
          </button>
        </div>
      </div>
    </section>
  );
};

export default Products;
